module.exports = __webpack_public_path__ + "img/fracpack-banner-home-bg.0e326c22.png";